<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else class="page-wrapper">
      <v-layout wrap>
        <v-flex class="title-screen" xs12>
          <span>{{ adminText('workflowsAll.announcements_06b01c4', 'Announcements') }}</span>
        </v-flex>
        <div class="mb-32 title-description">
          {{ adminText('workflowsAll.make_an_announcement_to_the_attendees_of_your_4a9fb1a', 'Make an announcement to the attendees of your event through the mobile app to keep them updated on everything related to the event. Here you can add or edit the announcements.') }}
        </div>
        <v-flex class="pb-16" xs12>
          <main-button depressed @click="goTo(routes.organizer.newAnnouncement)">
            {{ adminText('workflowsAll.create_announcement_dd8f115', 'Create announcement') }}
          </main-button>
        </v-flex>
        <v-flex xs12>
          <data-table
            :items="displayedRows"
            item-clickable
            :headers="workflowUi([
              { text: adminText('workflowsAll.title_768e0c1', 'Title'), align: 'left', value: 'title' },
              { text: adminText('workflowsAll.date_eb9a4bc', 'Date'), align: 'left', value: 'createdAt' },
              { text: adminText('workflowsAll.send_notification_6140a68', 'Send notification'), align: 'left', value: 'isPushNotification' },
            ])"
            @item-click="
              goTo(routes.organizer.displayAnnouncement, {
                eventId: eventId,
                id: $event.id,
              })
            "
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import DataTable from '../shared/data-table'
import Spinner from '../shared/spinner'
import { GET_EVENT_ANNOUNCEMENT } from '../../graphql/announcement.graphql.js'
import { apolloClient } from '../../apollo'
import { deleteAnnouncement, getAnnouncements } from '../../http.js'

export default {
  mixins: [WorkflowDisplay],
  name: 'announcement-list-container',
  components: {
    Spinner,
    DataTable,
  },
  props: {
    eventId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      announcements: [],
    }
  },
  computed: {
    displayedRows() {
      return this.announcements.map(item => ({ ...item, createdAt: this.workflowDate(item.createdAt, 'LL, H:mm') }))
    },
  },
  apollo: {
    getEventAnnouncements: {
      query: GET_EVENT_ANNOUNCEMENT,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          const { getAnnouncements: announcements } = data
          this.announcements = announcements.map(a => {
            return {
              ...a,
              createdAt: a.createdAt,
            }
          })
        }
      },
    },
  },
  async formatAnnouncements(announcements) {
    return announcements.map(a => {
      return {
        ...a,
        createdAt: a.createdAt,
      }
    })
  },
  async refetchAnnouncements() {
    const announcements = await getAnnouncements(this.eventId)
    this.announcements = this.formatAnnouncements(announcements)
  },
  async updated() {
    await this.refetchAnnouncements()
  },
}
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .page-wrapper{
    margin-top: 1.5rem !important
  }
}
</style>
